app.controller("SudoImportCandidatesController", [
    "$scope", "StaticData", "SysParam", "$http", "$state", "SudoUtilsService", "fileReader", "usSpinnerService", "ConfirmModal", "toastr", "$timeout",
    function ($scope, StaticData, SysParam, $http, $state, SudoUtilsService, fileReader, usSpinnerService, ConfirmModal, toastr, $timeout) {
        $scope.disabled = false;
        $scope.result = [];
        $scope.level = 'level01';
        $scope.levels = [
            { _id: 'level01', name: 'ბაკალავრიატი' },
            { _id: 'level04', name: 'მასწავლებლების პროგრამა' }
        ]

        $scope.accordion = { open: false };

        $scope.uploadExcelFile = function (files) {
            $timeout(function () {
                $scope.excelFile = files[0];
                $scope.fileName = files[0].name;
            }, 0);
        };

        $scope.import = function () {
            if ($scope.excelFile) {
                usSpinnerService.spin("root");
                var fd = new FormData();
                $scope.disabled = true;
                fd.append('excelFile', $scope.excelFile);
                fd.append('level', $scope.level)
                $http.post('/student/import/register', fd, {
                    headers: { 'Content-Type': undefined }
                }).then(function (res) {
                    usSpinnerService.stop("root");
                    toastr.success('იმპორტი დასრულებულია');
                    $scope.result = res.data.students;
                    $scope.disabled = false;
                }, function () {
                    usSpinnerService.stop("root");
                    toastr.warning('იმპორტის ხარვეზი');
                })
            }
        };

    }
]);
